import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import Swal from 'sweetalert2';

const Offerings = () => {
    const { isSidebarOpen } = useSidebar();
    const [searchQuery, setSearchQuery] = useState('');
    const [editingOfferingId, setEditingOfferingId] = useState(null);
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        sports_offered: "",
        status: "",
        user_id: isLoggedIn.user_id,
        user_name: isLoggedIn.name,
    })


    const url = process.env.REACT_APP_LINK;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = customers.filter((customer) =>
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, customers]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = async (indexToDelete, offeringId, offeringName) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: `Do you want to delete the offering "${offeringName}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                const res = await fetch(`${url}/offerings/${offeringId}`, {
                    method: "DELETE",
                });

                if (res.ok) {
                    const updatedCustomers = customers.filter((_, index) => index !== indexToDelete);
                    setCustomers(updatedCustomers);
                    setFilteredCustomers(updatedCustomers);

                    Swal.fire("Deleted!", "The offering has been deleted.", "success");
                } else {
                    Swal.fire("Error!", "Failed to delete offering.", "error");
                }
            } catch (error) {
                console.error("Delete error:", error);
                Swal.fire("Error!", "Something went wrong. Try again.", "error");
            }
        }
    };


    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = process.env.REACT_APP_LINK;
        const method = editingOfferingId ? "PUT" : "POST";
        const endpoint = editingOfferingId ? `${url}/offerings/change/${editingOfferingId}` : `${url}/offerings/igothousifyu`;

        try {
            const res = await fetch(endpoint, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            if (res.ok) {
                const savedOffering = await res.json();

                if (editingOfferingId) {
                    // Update existing
                    setCustomers(prev =>
                        prev.map(item => item.id === editingOfferingId ? savedOffering : item)
                    );
                    setFilteredCustomers(prev =>
                        prev.map(item => item.id === editingOfferingId ? savedOffering : item)
                    );
                } else {
                    // Add new
                    setCustomers(prev => [savedOffering, ...prev]);
                    setFilteredCustomers(prev => [savedOffering, ...prev]);
                }

                // Reset
                setFormData({
                    sports_offered: "", status: "", user_id: isLoggedIn.user_id,
                    user_name: isLoggedIn.name
                });
                setEditingOfferingId(null);
                setIsModalOpen(false);
            } else {
                const err = await res.json();
                alert(err.message || "Failed to save offering");
            }
        } catch (err) {
            console.error("Save error:", err);
            alert("Server error");
        }
    };



    useEffect(() => {
        const fetchOfferings = async () => {
            try {
                const res = await fetch(`${url}/offerings/all/${isLoggedIn.user_id}`);
                const data = await res.json();
                setCustomers(data.reverse()); // or data
                setFilteredCustomers(data.reverse());
            } catch (error) {
                console.error("Error fetching offerings:", error);
            }
        };

        fetchOfferings();
    }, []);




    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Services/Offerings</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Offers
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Customer Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>

                                <th>Service</th>

                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>{customer.sports_offered}</td>

                                        <td>{customer.status}</td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setFormData({
                                                        sports_offered: customer.sports_offered,
                                                        status: customer.status,
                                                    });
                                                    setEditingOfferingId(customer.id);
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index, customer.id, customer.sports_offered)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <OfferingModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                statusOptions={statusOptions}
                formData={formData}
                setFormData={setFormData}
                handleSubmit={handleSubmit}
            />

        </>
    );
};

export default Offerings;
